export default "__VITE_ASSET__D$qxOZ7V__"